import React from 'react';
import { ReactSVG } from 'react-svg';
import UIOptimisationRecommenderRightArrow from '@/assets/img/ui-optimisation-recommender/ui-optimisation-recommender-right-arrow.svg';

const RcmdUIOptimisationItem = (text: string, useUIOptimisationRecommender?: boolean) => {
  return useUIOptimisationRecommender ? {
    children: useUIOptimisationRecommender ? (<div className="rcmd-ui-optimisation-item">
      <div className="rcmd-ui-optimisation-item-text">{text}</div>
      <ReactSVG src={UIOptimisationRecommenderRightArrow} style={{ width: 12, height: 12, marginLeft: 8 }} />
    </div>) : null,
    className: useUIOptimisationRecommender ? 'rcmd-ui-optimisation-item-container' : '',
  } : {};
};

export default RcmdUIOptimisationItem;
